class SidePanelInterestsController {
  constructor($scope, $timeout, JPMCService, UserDataService) {
    // Dependencies
    this.JPMCService = JPMCService;
    this.UserDataService = UserDataService;
    this.timeout = $timeout;
    this.scope = $scope;

    // User Data to watch
    this.userInterest = this.getUserInterest();

    // Page Variables
    this.userValue = '';

    // Config for building out range slider
    this.sliderOptions = {
      floor: 0,
      ceil: 10,
      step: 1,
      hideLimitLabels: true,
      readOnly: true
    };

    // For patch to fix: https://github.com/rzajac/angularjs-slider/issues/79
    this.broadcast = () => {
      $timeout(() => {
        $scope.$broadcast('rzSliderForceRender');
      });
    };
  }
  getUserInterest() {
    return this.UserDataService.interests.find((interest) => {
      return interest.id === this.interestId;
    });
  }
  updateUserInterest() {
    this.userValue = this.userInterest.value;
    this.timeout(() => {
      this.scope.$broadcast('rzSliderForceRender');
    });
  }
}

SidePanelInterestsController.$inject = ['$scope', '$timeout', 'JPMCService', 'UserDataService'];

export default SidePanelInterestsController;



// WEBPACK FOOTER //
// ./src/components/sidePanelInterests/sidePanelInterests.controller.js